import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ContractFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredSalesOrdersBC, GetPaginatedFilteredSalesOrdersBCVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredSalesOrdersBC.query';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData }
  from '@/utils/data-helpers/PaginatedFilteredGridData';

import GetPaginatedFilteredSalesOrdersBCQuery from '@/graphql/contracts/getPaginatedFilteredSalesOrdersBC.query.gql';

export type PaginatedFilteredSalesOrders = PaginatedFilteredGridData<ContractFilterInput>;

export default function useGetBCSalesOrders() {
  const [_getSalesOrders] = useLazyQuery<
  GetPaginatedFilteredSalesOrdersBC,
  GetPaginatedFilteredSalesOrdersBCVariables
  >(GetPaginatedFilteredSalesOrdersBCQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getBCSalesOrders = async (params: PaginatedFilteredSalesOrders) => {
    const response = await _getSalesOrders({
      variables: {
        ...params,
      } as GetPaginatedFilteredSalesOrdersBCVariables,
    });

    return response?.data?.paginatedFilteredSalesOrdersByBillingCycles;
  };

  return { getBCSalesOrders };
}
